/**
 * Ссылка «открыть на карте» для адреса игры.
 *
 * Клиент в Казахстане, поэтому карта — всегда 2ГИС Казахстан (домен .kz),
 * а не российский 2gis.ru (иначе поиск по голому тексту открывал адреса
 * в США/Канаде/России).
 *
 * Приоритет:
 *  1. есть координаты geo → прямая точка на карте (.kz);
 *  2. в адрес вставили готовую ссылку (http/https) → открываем её как есть;
 *  3. обычный текст → поиск по 2gis.kz, к адресу добавляем город филиала
 *     (если он передан и его ещё нет в самом адресе).
 */
export function mapUrl(
  address?: string | null,
  geo?: { lng: number; lat: number } | null,
  city?: string | null,
): string {
  if (geo) return `https://2gis.kz/geo/${geo.lng},${geo.lat}`;

  const addr = (address ?? '').trim();
  if (!addr) return 'https://2gis.kz';

  // В адрес вставили готовую ссылку на карту — открываем напрямую, ничего не ищем.
  if (/^https?:\/\//i.test(addr)) return addr;

  const c = (city ?? '').trim();
  const query = c && !addr.toLowerCase().includes(c.toLowerCase())
    ? `${addr} ${c}`
    : addr;

  return `https://2gis.kz/search/${encodeURIComponent(query)}`;
}
